// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const PencilOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m63.72 19.679 12.598 12.598 6.262-6.262a3.146 3.146 0 0 0 0-4.444l-8.154-8.154a3.148 3.148 0 0 0-4.444 0l-6.262 6.262ZM19.498 63.9l12.598 12.597L73.49 35.105 60.892 22.508 19.498 63.9Zm-1.839 3.818-4.247 14.866 14.867-4.248-10.62-10.618ZM10.5 87.497a2 2 0 0 1-1.923-2.55l6.161-21.561a1.983 1.983 0 0 1 .515-.896v-.001l.003-.002 51.898-51.898c2.783-2.785 7.313-2.785 10.1-.001l8.154 8.155c2.785 2.784 2.785 7.315 0 10.1L33.51 80.74l-.003.002c0 .003-.003.004-.003.003a1.984 1.984 0 0 1-.893.514l-21.56 6.16a2.034 2.034 0 0 1-.55.077Z"
			fill="#fff"
		/>
	</svg>
);
export default PencilOutline;
